import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-09-26 11:29:45
 * @LastEditTime: 2021-12-17 14:56:52
 * @LastEditors: wangshengqiang
 * @Description: 通用要素-保障期间
 */
import React, { useEffect } from 'react';
import RowRadioList from '../RowRadioList';
export default (props => {
  const {
    attrs = {}
  } = props;

  const _attrs = JSON.parse(JSON.stringify(attrs));

  const {
    dataSource = [],
    display = {}
  } = _attrs;

  const _optins = dataSource.map(item => _objectSpread(_objectSpread({}, item), {}, {
    value: Array.isArray(item.value) ? item.value.join('-') : item.value
  }));

  props.attrs.dataSource = _optins;
  let initialValue;

  if (display.hasDefaultValue && display.defaultValue) {
    const pdefaultValue = JSON.parse(display.defaultValue); // eslint-disable-next-line no-undef

    initialValue = Array.isArray(pdefaultValue) ? pdefaultValue.join('-') : pdefaultValue;
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RowRadioList, _extends({}, props, {
    initialValue: initialValue
  })));
});